<template>
  <footer class="footer-wrapper">
    <div class="platinum-footer">
      <div class="footer-body">
        <div class="footer-identity">
          <img
            alt="platinum-logo"
            class="kariermu-footer-logo"
            :src="platinumLogoUrl"
          />
          <div class="copyright text-gargoyle fs-12 fw-600 fl-16">
            © {{ currentYear }} Karier.mu. PT Semesta Integrasi Digital. Rights Reserved.
          </div>
        </div>
        <div class="footer-widget">
          <img
            alt="ISO/IEC 27001"
            class="icon-size"
            src="https://cdn.karier.mu/assets/v3/icon/iso-certified.webp"
          >
          <img
            alt="aws active"
            class="icon-size"
            src="https://cdn.karier.mu/assets/v3/icon/aws-active.webp"
          >
          <img
            alt="kominfo registered"
            class="icon-size"
            src="https://cdn.karier.mu/assets/v3/icon/kominfo-registered.webp"
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PlatinumFooter',
  computed: {
    platinumLogoUrl () {
      return this.$store.state.institution.platinumInstitutionInfo?.logo_2 || 'https://cdn.karier.mu/kariermu/assets/logo/kariermu-2023.webp'
    },
    currentYear () {
      return new Date().getFullYear().toString()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@sekolahmu/sekolahmu-design-system-next/src/styles/mixins/_breakpoint.scss';

.platinum-footer {
  padding-top: 48px;
  padding-bottom: 88.5px;
  background-color: var(--color-background-white);
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  background-image: url("https://cdn.karier.mu/kariermu/2023/assets/bg-mweb.svg");
}

.footer-body {
  width: 100%;
  max-width: 1140px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 24px;
}

.footer-widget {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 166px;
  gap: 16px;
  padding: 16px;
}

.footer-identity {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  max-width: 279px;
  gap: 32px;
}

.kariermu-footer-logo {
  width: auto;
  max-height: 32px;
}

.iso-logo {
  width: 100%;
  max-width: 32.27px;
  height: auto;
}

.icon-size {
  width: 38.4px;
  height: 38.4px;
}

.copyright {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

@include desktop {
  .platinum-footer {
    padding-top: 32px;
    padding-bottom: 85px;
    background-image: url("https://cdn.karier.mu/kariermu/2023/assets/bg-web.svg");
  }

  .icon-size {
    width: 48px;
    height: 48px;
  }

  .footer-body {
    width: 100%;
    max-width: 1140px;
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .iso-logo {
    width: 100%;
    max-width: 40.33px;
    height: auto;
  }

  .footer-widget {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 208px;
    gap: 16px;
    padding: 16px;
  }

  .copyright {
    justify-content: flex-start;
  }

  .footer-identity {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    max-width: 395px;
  }

  .kariermu-footer-logo {
    max-width: 189px;
  }
}
</style>
